<template lang="pug">
  app-toolbar

    template(v-if="rootCategory && rootCategory.alias == 'common'")

      .sud-toolbar-item 
        span.mr-2 Сортировка
      
        v-menu(open-on-hover offset-y content-class="sud-toolbar-menu" nudge-bottom="10" close-delay="300" allow-overflow)
          template(v-slot:activator="{ on }")
            .sud-toolbar-item__activator(style="min-width:120px" v-on="on") {{ filter.sort ? filter.sort.text : 'без сортировки' }}

          v-list.p-0.sud-toolbar-menu__list(dense)
            //div
              v-list-item.sud-toolbar-menu__item(@click.native="setSort(null)")
                .sud-toolbar-menu__item-content нет
            div.sud-toolbar-menu__list
              v-list-item.sud-toolbar-menu__item(v-for="(item,index) in sortList.byTitle" :key="index" @click.native="setSort(item)")
                .sud-toolbar-menu__item-content {{ item.text }}
            
      .sud-toolbar-item.ml-6
        app-toolbar-item-period.ml-6(@select="setPeriod") {{ filter.date ? filter.date.text : 'все' }}

    template(v-else)

      .sud-toolbar-item
        span.mr-2 Сортировка

        v-menu(open-on-hover offset-y content-class="sud-toolbar-menu" nudge-bottom="10" close-delay="300" allow-overflow)
          template(v-slot:activator="{ on }")
            .sud-toolbar-item__activator(style="min-width:120px" v-on="on") {{ filter.sort ? filter.sort.text : 'без сортировки' }}

          v-list.p-0.sud-toolbar-menu__list(dense)
            //div
              v-list-item.sud-toolbar-menu__item(@click.native="setSort(null)")
                .sud-toolbar-menu__item-content нет
            div.sud-toolbar-menu__list
              v-list-item.sud-toolbar-menu__item(v-for="(item,index) in sortList.byYear" :key="index" @click.native="setSort(item)")
                .sud-toolbar-menu__item-content {{ item.text }}

      .sud-toolbar-item.ml-6
        span.mr-2 Год

        v-menu(open-on-hover offset-y content-class="sud-toolbar-menu" nudge-bottom="10" close-delay="300" allow-overflow)
          template(v-slot:activator="{ on }")
            .sud-toolbar-item__activator(style="min-width:120px" v-on="on") {{ filter.year ? filter.year : 'все' }}

          v-list.p-0.sud-toolbar-menu__list(dense)
            div
              v-list-item.sud-toolbar-menu__item(@click.native="setFilterYear('all')")
                .sud-toolbar-menu__item-content все
            div.sud-toolbar-menu__list
              v-list-item.sud-toolbar-menu__item(@click.native="setFilterYear('cur')")
                .sud-toolbar-menu__item-content текущий год ({{ getCurrentYear }})
              v-list-item.sud-toolbar-menu__item(@click.native="setFilterYear('choose')") 
                .sud-toolbar-menu__item-content выбрать год

      app-toolbar-item.ml-6(label="Тип делопроизводства:" :items="sTypeList" keyName="text" @select="setType") {{ filter.type ? filter.type.text : 'все' }}

    dialog-choose-year(v-model="dialog.editDoc" ref="dialogChooseYear")
    
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
moment.locale('ru')

import dialogChooseYear from "./KnowledgeBaseDialogChooseYear"

export default {
  name: 'knowledgebase-toolbar',
  components: {
    dialogChooseYear
  },
  computed: {
    ...mapState('knowledgeBase', ['filter','typeList','sortList','knowledgeCategory']),

    sTypeList(){
      let t = [{value:-1,text:'все'}]
      t = t.concat(this.typeList);
      return t
    },

    getCurrentYear() {
      return moment().format('YYYY')
    },

    rootCategory(){
      if (this.filter.category) return this.findRootCatSelected(this.filter.category)
      return null
    },
  },
  methods: {
    ...mapActions('knowledgeBase', ['setType', 'setYear', 'setPeriod', 'setSort']),

    findRootCatSelected(item){
      return this.findRootCatSelectedRec(this.knowledgeCategory,item)
    },

    findRootCatSelectedRec(arr,item){
      let rootCat = arr.filter(i => {return i.id == item.id})[0]
      if (!rootCat){
        for (let itm of arr) {
          let cc = this.findRootCatSelectedRec(itm.children,item)
          if (cc) {
            rootCat = itm
            break
          }
        }
      }
      return rootCat
    },

    setFilterYear(mode){
      switch(mode){
        case 'all':
          this.setYear(null);
          break;
        case 'cur':
          this.setYear(this.getCurrentYear);
          break;
        case 'choose':
          this.$refs.dialogChooseYear.show()
          break;
      }
    }
  },

  data () {
    return {
      dialog: {
        chooseYear: false
      }
    }
  }
}
</script>